var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main-dialog", {
    ref: "dialog",
    attrs: {
      heading: "parkingLot.allocatePromotion.heading",
      "btn-confirm-text": "actions.allocate",
      "has-activator": _vm.hasActivator,
      "confirm-btn-disabled": _vm.allocateInProgress,
      "dialog-style": { width: "800px" },
    },
    on: {
      confirm: _vm.allocatePromotionsDialogConfirm,
      close: _vm.closeDialog,
    },
    scopedSlots: _vm._u(
      [
        _vm.hasActivator
          ? {
              key: "actions",
              fn: function ({ activator }) {
                return [
                  _c(
                    "icon",
                    _vm._g(
                      {
                        attrs: { "icon-name": "duplicate", small: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      activator
                    )
                  ),
                ]
              },
            }
          : null,
        {
          key: "default",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "allocate-promotion" },
                [
                  _c("p", { staticClass: "allocate-promotion__description" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("toSentenceCase")(
                            _vm.$t("parkingLot.allocatePromotion.description")
                          )
                        ) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("vuex-select", {
                    staticClass: "py-2",
                    attrs: {
                      placeholder: _vm.$tc("entities.subCampaigns", 2),
                      options: _vm.availableSubCampaigns,
                      "item-text": "name",
                      "item-value": "_id",
                      getter: () => _vm.selectedSubCampaigns,
                      setter: (value) => (_vm.selectedSubCampaigns = value),
                      multiple: "",
                      chips: "",
                      "deletable-chips": "",
                      clearable: "",
                      preserveInputOnSelect: "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.requestInProgress
                ? _c(
                    "div",
                    { staticClass: "in-progress--message" },
                    [
                      _c("label", { staticClass: "in-progress__message" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("toSentenceCase")(
                              _vm.$t(
                                "parkingLot.allocatePromotion.inProgressMessage"
                              )
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("spinner-dynamic"),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }